export const DESTINO_VM = "VM";
export const DESTINOS_SEDE_2 = [
  "Tercera Rotonda",
  "Centenario",
  "Serranías Puntanas",
];

const normalizeDestinoKey = (value = "") =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const DESTINOS_SEDE_2_MAP = new Map(
  DESTINOS_SEDE_2.map((destino) => [normalizeDestinoKey(destino), destino])
);

export const requiereDestinoExplicito = (idSede) => Number(idSede || 0) === 2;

export const resolveDestinoForSede = ({ idSede, destino } = {}) => {
  const sedeId = Number(idSede || 1);

  if (sedeId === 1) return DESTINO_VM;

  if (requiereDestinoExplicito(sedeId)) {
    return DESTINOS_SEDE_2_MAP.get(normalizeDestinoKey(destino)) || "";
  }

  return String(destino || "").trim() || DESTINO_VM;
};
